import PropTypes from 'prop-types'
import { createContext, useContext, useState, useCallback } from 'react'

// Create the context (not exported outside)
const PriceModalContext = createContext(null)

/**
 * Provider component for managing price modals on a page
 */
export const PriceModalProvider = ({ children }) => {
  // currently active modal ('confirmation', 'scrap', 'salvage', 'bestPrice')
  const [activeModal, setActiveModal] = useState(null)
  // optional payload for modal data (agent, maxPrice, vehicleConditionData, etc.)
  const [modalPayload, setModalPayload] = useState(null)

  // open a modal by name and optionally pass payload
  const openModal = useCallback((modalName, payload = null) => {
    setActiveModal(modalName)
    setModalPayload(payload)
  }, [])

  // close all modals
  const closeModal = useCallback(() => {
    setActiveModal(null)
    setModalPayload(null)
  }, [])

  return (
    <PriceModalContext.Provider
      value={{
        activeModal,
        modalPayload,
        openModal,
        closeModal,
      }}
    >
      {children}
    </PriceModalContext.Provider>
  )
}

PriceModalProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

/**
 * Hook to access the modal context
 */
export const usePriceModalContext = () => {
  const context = useContext(PriceModalContext)
  if (!context) {
    throw new Error(
      'usePriceModalContext must be used inside a PriceModalProvider'
    )
  }
  return context
}
